(ns common.schema.entities.graph-company
  (:require [common.schema.entities.graph-entity :as graph-entity]))

(def schema
  (concat
   graph-entity/schema

   graph-entity/business-id

   graph-entity/jurisdiction
   graph-entity/domicile
   graph-entity/legal-form

   graph-entity/giin
   graph-entity/tin
   graph-entity/duns-number))
